import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'

import {
  postApprovalSubmissionsListAPI,
  postRejectSubmissionsAPI,
  postApproveSubmissionsAPI,
} from 'features/AdsManagement/services/principalList'

import { normalizeApprovalListPaginationCursors } from 'features/AdsManagement/helpers/normalizeApprovalListCursor'
import { AdsApprovalSubmissionsParamInterface } from 'features/AdsManagement/@types/apiTypes'
import { toastFailed, toastSuccess } from 'utils/toast'

import { setIsLoading, setApprovalList, setPagination, SLICE_NAME } from './slice'

export const fetchApprovalList = createAsyncThunk(
  `${SLICE_NAME}/fetchPrincipalDetailList`,
  async (
    { params }: { params: AdsApprovalSubmissionsParamInterface },
    { rejectWithValue, dispatch },
  ) => {
    dispatch(setIsLoading(true))
    try {
      const response = await postApprovalSubmissionsListAPI(params)
      dispatch(setApprovalList(response.data.data.approval_submissions))
      dispatch(setPagination(normalizeApprovalListPaginationCursors(response.data.pagination)))
      dispatch(setIsLoading(false))

      return true
    } catch (error) {
      dispatch(setIsLoading(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const postApproveSubmissions = createAsyncThunk(
  `${SLICE_NAME}/postApproveSubmissions`,
  async ({ submissionId }: { submissionId: string }, { rejectWithValue, dispatch }) => {
    dispatch(setIsLoading(true))
    try {
      const response = await postApproveSubmissionsAPI(submissionId)

      if (response.data.error.status) {
        toastFailed(response.data.error.message)
        dispatch(setIsLoading(false))
        return rejectWithValue(response.data.error.message)
      }

      dispatch(setIsLoading(false))
      toastSuccess('Pengajuan Top Up berhasil diterima!')

      return response
    } catch (error) {
      dispatch(setIsLoading(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const postRejectSubmissions = createAsyncThunk(
  `${SLICE_NAME}/postRejectSubmissions`,
  async (
    { submissionId, rejectionNote }: { submissionId: string; rejectionNote: string },
    { rejectWithValue, dispatch },
  ) => {
    dispatch(setIsLoading(true))
    try {
      const response = await postRejectSubmissionsAPI(submissionId, rejectionNote)

      if (response.data.error.status) {
        toastFailed(response.data.error.message)
        dispatch(setIsLoading(false))
        return rejectWithValue(response.data.error.message)
      }

      dispatch(setIsLoading(false))
      toastFailed('Pengajuan Top Up berhasil ditolak!')

      return response
    } catch (error) {
      dispatch(setIsLoading(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)
